import { styled } from '@material-ui/core';

export const MainContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: 15,
}));

export const SectionContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: 10,
}));

export const ScrollableContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  gap: 20,
  overflowX: 'auto',
  paddingBottom: 10,
  width: 'auto',
}));

export const ImageContainer = styled('div')({
  maxWidth: 200,
  display: 'flex',
  flexDirection: 'column',
  gap: 10,
});

export const Image = styled('img')({
  minWidth: 50,
  width: 'auto',
  height: 112,
  objectFit: 'cover',
  objectPosition: 'top',
  borderRadius: 8,
});

export const ItemContainer = styled('div')({
  width: '100%',
  maxWidth: 250,
  display: 'flex',
  flexDirection: 'column',
  gap: 10,
});

export const VideoItemCont = styled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  maxWidth: 250,
  minHeight: 112,
  minWidth: 250,
  borderRadius: 8,
  '& .profile-video-item': {
    width: '100%',
    borderRadius: 10,
  },
  position: 'relative',
}));
